import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ProductShape } from '../../../lib/util/productShape';
import { DropoffCheckoutTab } from './DropoffCheckoutTab/DropoffCheckoutTab';
import { PickupCheckinTab } from './PickupCheckinTab/PickupCheckinTab';
import { ScheduleTab } from './ScheduleTab/ScheduleTab';
import { TabPane, Tabs } from './Tabs/Tabs';

interface OwnProps {
  product: ProductShape;
}

type Props = OwnProps;

export const ProductOutline = ({ product }: Props) => {
  const { t } = useTranslation();

  const tabPanes: TabPane[] = [];
  if (product.schedule.length > 0) {
    tabPanes.push({
      header: t('Schedule'),
      content: () => <ScheduleTab product={product} />,
    });
  }

  if (product.pickupLocations.length > 0 || product.checkinLocations.length > 0) {
    tabPanes.push({
      header: t('Pickup / Checkin'),
      content: () => <PickupCheckinTab product={product} />,
    });
  }

  if (product.dropoffLocations.length > 0 || product.checkoutLocations.length > 0) {
    tabPanes.push({
      header: t('Dropoff / Checkout'),
      content: () => <DropoffCheckoutTab product={product} />,
    });
  }

  return <Tabs panes={tabPanes} />;
};
